
import CompanyDetailsView from '@/components/CompanyDetailsView.vue';
import ShowPopup from '@/components/ShowPopup.vue';
import { mainStore } from '@/store';
import { retencaoFinanceiraStore } from '@/utils/store-accessor';
import { Component, Vue, Watch } from 'vue-property-decorator';
import ListTitulosSyngoo from './ListTitulosSyngoo.vue';

@Component({
  components: {
    ShowPopup,
    CompanyDetailsView,
    ListTitulosSyngoo,
  },
})
export default class ListSendMessages extends Vue {
  @Watch('propStateTitulo', { immediate: true, deep: true })
  async getSolicitacoes() {
    if (this.propStateTitulo > 0) {
      this.unidades_retencao = await retencaoFinanceiraStore.getRetencaoFinanceiraSendMessage();
    }
  }

  public isLoading = false;
  public propStateTitulo = 0;
  public itemUnidade = [];
  public unidades_retencao = [];
  public propId = 0;
  public c014Unidade = 0;
  public unidadeGestaoAdm = 0;
  public filtroAdimplente = 0;
  public filtroGestao = 1;
  public deveDesde = 0;
  public propDias = 0;

  public currentTab = 0;

  public headerGeral = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'Nome/Razão Social',
      sortable: false,
      value: 'C014_NomeRazaoSocial',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    // {
    //   text: "Venda PF",
    //   sortable: true,
    //   value: "allow_invoice_aluno",
    //   align: "center",
    // },
    // {
    //   text: "Venda PJ",
    //   sortable: true,
    //   value: "allow_invoice_company",
    //   align: "center",
    // },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    // {
    //   text: "KNN",
    //   sortable: true,
    //   value: "valor_em_atraso_knn_brasil",
    //   align: "left",
    // },
    // {
    //   text: "Fundo",
    //   sortable: true,
    //   value: "valor_em_atraso_fundo_de_prop",
    //   align: "left",
    // },
    // {
    //   text: "PF",
    //   sortable: true,
    //   value: "valor_em_atraso_pf",
    //   align: "left",
    // },
    // {
    //   text: "Total",
    //   sortable: true,
    //   value: "total",
    //   align: "left",
    // },
    // // {
    //   text: "Deve desde",
    //   sortable: true,
    //   value: "dias_devendo",
    //   align: "center",
    // },
    {
      text: 'Status Mensagem',
      sortable: false,
      value: 'status_mensagem',
      align: 'center',
    },
    {
      text: 'Ações',
      sortable: false,
      value: 'actions',
      align: 'center',
    },
  ];

  public headerLivros = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'Nome/Razão Social',
      sortable: false,
      value: 'C014_NomeRazaoSocial',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    // {
    //   text: "Venda PF",
    //   sortable: true,
    //   value: "allow_invoice_aluno",
    //   align: "center",
    // },
    // {
    //   text: "Venda PJ",
    //   sortable: true,
    //   value: "allow_invoice_company",
    //   align: "center",
    // },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    // {
    //   text: "Valor Vencido",
    //   sortable: true,
    //   value: "valor_atraso_livro",
    //   align: "center",
    // },
    // {
    //   text: "Deve desde",
    //   sortable: true,
    //   value: "dias_devendo_livro",
    //   align: "center",
    // },
    // {
    //   text: "Status Cobrança",
    //   sortable: false,
    //   value: "status_cobranca",
    //   align: "center",
    // },
    {
      text: 'Status Mensagem',
      sortable: false,
      value: 'status_mensagem',
      align: 'center',
    },
    {
      text: 'Ações',
      sortable: false,
      value: 'actions',
      align: 'center',
    },
  ];

  public async handleSendMessageSyngoo3(item: any) {
    let form: any = null;
    this.itemUnidade = item;
    this.propDias = 3;
    this.propId = item.id;
    form = this.$refs.listFinanceiro;
    form.show();
  }

  public async handleSendMessageSyngoo(item: any) {
    let form: any = null;
    this.itemUnidade = item;
    this.propDias = 0;
    this.propId = item.id;
    form = this.$refs.listFinanceiro;
    form.show();
  }

  get allItemsGeral() {
    let item = this.unidades_retencao[1];

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    return item;
  }

  get allItemsLivros() {
    let item = this.unidades_retencao[0];

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    return item;
  }

  public async handleAddUnidade(item) {
    let form: any = null;
    this.itemUnidade = item;
    this.propId = 0;
    form = this.$refs.addUnidade;
    form.show();
  }

  public async handleSendSyngoo() {}

  // public async handleSendBoletoSyngoo() {
  //   let res = await retencaoFinanceiraStore.enviaBoletoSyngooTresDias({
  //     t022: 57345,
  //     fone: "5547999570044",
  //   });
  // }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async mounted() {
    this.isLoading = true;

    await mainStore.userProfile;

    this.unidades_retencao = await retencaoFinanceiraStore.getRetencaoFinanceiraSendMessage();

    this.isLoading = false;
  }
}
